import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppUser, Listing } from '../../../types';
import { listingsOwnedBy } from '../../../utils/superAdmin';
import { pickLang } from '../../../utils/listingDisplay';
import CategoryIcon from '../../directory/CategoryIcon';

/** Everyone with an account, and the listings each one owns. */
export default function PeopleTab({ listings, users }: { listings: Listing[]; users: AppUser[] }) {
  const { t, i18n } = useTranslation();
  const isHebrew = i18n.language === 'he';

  if (users.length === 0) return <p className="text-sm text-ash">{t('directory.super.people.none')}</p>;

  return (
    <div className="space-y-3">
      <p className="text-sm text-ash">{t('directory.super.people.intro')}</p>
      <ul className="space-y-2">
        {users.map((u) => {
          const owned = listingsOwnedBy(listings, u.uid);
          return (
            <li key={u.uid} className="rounded-[16px] border border-ink/10 bg-paper px-4 py-3 space-y-1">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="min-w-0">
                  {u.displayName && <p className="text-sm font-medium text-ink">{u.displayName}</p>}
                  <p className="text-sm text-ash break-all" dir="ltr">{u.email}</p>
                </div>
                <span className="text-xs text-ash">{t(`directory.super.people.role.${u.role === 'superAdmin' ? 'superAdmin' : 'owner'}`)}</span>
              </div>
              {owned.length === 0 ? (
                <p className="text-xs text-ash">{t('directory.super.people.noListings')}</p>
              ) : (
                <ul className="space-y-0.5">
                  {owned.map((l) => (
                    <li key={l.id}>
                      <Link to={`/admin?item=${l.id}`} className="inline-flex items-center gap-2 min-h-[32px] text-sm text-ink hover:underline">
                        <CategoryIcon category={l.category} className="w-4 h-4" strokeWidth={1.5} />
                        {pickLang(l.nameEn, l.nameHe, isHebrew)}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
